import PageTemplate from "../components/common/PageTemplate";
import HOC from "../components/HOC";
import PurchaseList from "../screen/purchase/PurchaseList";

const PurchasePage = () => {
  return <PageTemplate mainComponent={<PurchaseList />} noPadding={true} />;
};

export default HOC(PurchasePage, "no-doctor");